export const GET_DATA_ADMIN_DASHBOARD = 'src/components/admin/admin-dashborad/action/GET_DATA_ADMIN_DASHBOARD';
export const GET_DATA_ADMIN_DASHBOARD_SUCCESS = 'src/components/admin/admin-dashborad/action/GET_DATA_ADMIN_DASHBOARD_SUCCESS';
export const GET_DATA_ADMIN_DASHBOARD_FAILURE = 'src/components/admin/admin-dashborad/action/GET_DATA_ADMIN_DASHBOARD_FAILURE';

export const getDataAdminDashboard = (data) => {
    return {
        type: GET_DATA_ADMIN_DASHBOARD,
        data
    }
}
export const getDataAdminDashboardSuccess = (data) => {
    return {
        type: GET_DATA_ADMIN_DASHBOARD_SUCCESS,
        data
    }
}
export const getDataAdminDashboardFailure = (data) => {
    return {
        type: GET_DATA_ADMIN_DASHBOARD_FAILURE,
        data
    }
}